import React, {ReactElement, useState, useContext} from 'react';
import {
  Button,
  ShareIcon,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box
} from '@customink/pigment-react';
import {useStoreSlug} from '../../hooks';
import CopyLinkTextButton from '../CopyLinkTextButton';
import {MobileContext} from '../../containers/MobileProvider';
import services from '../../api/remoteServices';
import './index.scss';

const GroupShareDialog: React.FC = (): ReactElement => {
  const urlSlug = useStoreSlug();
  const storeUrl = `${services.storefront}/${urlSlug}`;
  const noHttpStoreUrl = storeUrl.replace(/^https?:\/\//, '');

  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const mobile = useContext(MobileContext);

  const handleOpen = () => setShareDialogOpen(true);
  const handleClose = () => setShareDialogOpen(false);

  const shareDialogContentClasses = `shareDialog-content${
    mobile ? ' mobile' : ''
  }`;
  return (
    <div className="shareDialog">
      <Button
        variant="link"
        startIcon={<ShareIcon />}
        onClick={handleOpen}
        size="small"
        className="shareDialog-button">
        Share
      </Button>
      <Dialog
        title="Share Page"
        open={shareDialogOpen}
        onClose={handleClose}
        width="md"
        titleSx={{paddingBottom: '0.75rem'}}
        padding={{
          paddingTop: '1.5rem',
          paddingBottom: '2.5rem'
        }}>
        <DialogContent className={shareDialogContentClasses}>
          <Typography variant="bodyShort1">
            Share your link so your group members can place their orders:
          </Typography>
          <Box sx={{paddingTop: '2rem', textAlign: 'center', fontWeight: 700}}>
            <Typography variant="bodyShort2">{noHttpStoreUrl}</Typography>
          </Box>
        </DialogContent>
        <DialogActions className="shareDialog-actions">
          <CopyLinkTextButton
            copyLink={storeUrl}
            size="medium"
            variant="primary"
            fullWidth
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GroupShareDialog;
